import axios from "axios";
import { REACT_APP_API,GENAI_URL} from "../environment";

const getTokenFromStorage = () => {
    return sessionStorage.getItem("token");
};
const token = getTokenFromStorage();

let headers = {
    "Content-Type": "application/json",
    "Authorization": token,
};

let newheaders = {
    'Content-Type': 'application/json',
};

export const getAdskEmpList = (searchStr) => {
    headers['username'] = searchStr;
    return axios.get(`${REACT_APP_API}/getAllAdUsers`, { headers: headers });
}

export const fetchGenAiSummary = async (description) => {
        const response = await axios.post(GENAI_URL, {text: description}, {headers:newheaders});
        return response.data.summary;
};

